/*!
=========================================================
* Painel Toca da Onça — Clientes (lista real + busca)
=========================================================
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Input, Table, Badge, Button } from "reactstrap";

function TableList() {
  const [clientes, setClientes] = React.useState([]);
  const [busca, setBusca] = React.useState("");

  React.useEffect(() => {
    fetch("/clientes.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && d.clientes) setClientes(d.clientes); })
      .catch(() => {});
  }, []);

  const b = busca.trim().toLowerCase();
  const filtrados = b
    ? clientes.filter((c) => (c.nome || "").toLowerCase().includes(b) || (c.tel || "").includes(b) || (c.uf || "").toLowerCase() === b)
    : clientes;
  const mostrar = filtrados.slice(0, 100);

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Clientes</h3>
          <p className="text-muted">
            Sua base tem <b className="text-white">{clientes.length.toLocaleString("pt-BR")} contatos</b> nomeados.
            Busque por nome, telefone ou estado.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar cliente (nome, telefone ou UF)..." style={{ height: 44 }} />
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">
                {b ? `${filtrados.length} encontrado(s)` : `${clientes.length.toLocaleString("pt-BR")} clientes`}
                {filtrados.length > 100 && <span className="text-muted" style={{ fontSize: 13 }}> — mostrando os 100 primeiros</span>}
              </CardTitle>
            </CardHeader>
            <CardBody>
              <Table className="tablesorter" responsive>
                <thead className="text-primary">
                  <tr><th>Nome</th><th>Telefone</th><th className="text-center">DDD</th><th className="text-center">UF</th><th className="text-center">WhatsApp</th></tr>
                </thead>
                <tbody>
                  {mostrar.map((c, i) => (
                    <tr key={i}>
                      <td>{c.nome}</td>
                      <td>{c.tel}</td>
                      <td className="text-center">{c.ddd || "—"}</td>
                      <td className="text-center">{c.uf ? <Badge color="primary" pill>{c.uf}</Badge> : "—"}</td>
                      <td className="text-center">
                        <Button size="sm" color="success" tag="a" target="_blank" href={"https://wa.me/55" + c.tel}>
                          <i className="fab fa-whatsapp" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {mostrar.length === 0 && <tr><td colSpan="5" className="text-muted">{clientes.length ? "Nenhum cliente com esse termo." : "Carregando contatos..."}</td></tr>}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default TableList;
